import { render } from "./JobReason.vue?vue&type=template&id=b6272bb2&scoped=true"
import script from "./JobReason.vue?vue&type=script&lang=js"
export * from "./JobReason.vue?vue&type=script&lang=js"

import "./JobReason.vue?vue&type=style&index=0&id=b6272bb2&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6272bb2"]])

export default __exports__